"use strict";

exports.__esModule = true;
exports.metricMtcDefinition = void 0;
var metricMtcDefinition = exports.metricMtcDefinition = function metricMtcDefinition(translate) {
  return {
    columns: [{
      id: "day",
      name: translate("DataTable.Column.Title.Day", "Day"),
      type: "date",
      dateFormat: "LongDateTime",
      usePlantTime: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }, {
      id: "data_item_type",
      name: translate("DataTable.Column.Title.DataItemType", "Data Item Type"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }, {
      id: "data_item_name",
      name: translate("DataTable.Column.Title.DataItemName", "Data Item Name"),
      type: "string",
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }, {
      id: "average",
      name: translate("DataTable.Column.Title.Average", "Average"),
      type: "number",
      isAggregated: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }, {
      id: "minimum",
      name: translate("DataTable.Column.Title.Minimum", "Minimum"),
      type: "number",
      isAggregated: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }, {
      id: "maximum",
      name: translate("DataTable.Column.Title.Maximum", "Maximum"),
      type: "number",
      isAggregated: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }, {
      id: "sum",
      name: translate("DataTable.Column.Title.Sum", "Sum"),
      type: "number",
      isAggregated: true,
      canSearch: true,
      canFilter: true,
      showSearchFilter: true,
      enableSorting: true
    }],
    parseData: function parseData(responseData) {
      return responseData;
    },
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        enablePagination: true,
        overFetchAll: true,
        defaultPageSize: "auto",
        columns: [{
          id: "day",
          name: translate("DataTable.Column.Title.Day", "Day"),
          type: "date",
          dateFormat: "ShortDate",
          usePlantTime: true,
          canSearch: true,
          canFilter: true,
          showSearchFilter: true
        }, {
          id: "data_item_type",
          name: translate("DataTable.Column.Title.DataItemType", "Data Item Type"),
          type: "string",
          canSearch: true,
          canFilter: true,
          enableSorting: true,
          showSearchFilter: true
        }, {
          id: "data_item_name",
          name: translate("DataTable.Column.Title.DataItemName", "Data Item Name"),
          type: "string",
          canSearch: true,
          canFilter: true,
          enableSorting: true,
          showSearchFilter: true
        }, {
          id: "average",
          name: translate("DataTable.Column.Title.Average", "Average"),
          type: "number",
          isAggregated: true,
          canSearch: true,
          canFilter: true,
          showSearchFilter: true,
          enableSorting: true
        }]
      };
    }
  };
};